import styled from "styled-components";
import { Link } from "react-router-dom";
import { Box } from "@material-ui/core";
import BGDesktop1 from "../../assets/images/BGDesktop1.png";
import BGMobile from "../../assets/images/BGMobile.png";

import { fontstyles, animationstyles } from "../../theme/commonstyles";

export const StyledContainer = styled(Box)`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  @media (min-width: 900px) {
    background: url(${BGDesktop1}) no-repeat;
    background-size: cover;
    background-position: center;
  }
  @media (max-width: 900px) {
    background: url(${BGMobile}) no-repeat;
    background-size: cover;
    background-position: center;
  }

  ${fontstyles};
  ${animationstyles};

  #container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  #texts {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    @media (min-width: 1000px) {
      padding: 0;
    }
  }

  #texts .wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (min-width: 900px) {
      width: 100%;
      margin: auto;
    }
  }

  #button {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #title,
  #text {
    color: ${(props) => props.theme.palette.background.main};
  }

  #title {
    margin-bottom: 1rem;
    margin: 2rem 0;
    text-align: center;
  }

  h3 {
    font-weight: bolder;
    font-family: opensans;

    @media (min-width: 900px) {
      font-size: 3.5vw;
    }
  }

  p {
    margin-top: 1rem;
    font-family: opensans;
  }
  .disque {
    position: absolute;
    right: 15%;
    top: 5%;
    width: 12%;
    @media (max-width: 900px) {
      width: 30%;
    }
    > img {
      max-width: 100%;
      box-sizing: border-box;
    }
  }
`;

export const Iniciar = styled(Link)`
  background-color: ${(props) => props.theme.palette.button.start};
  border-radius: 200px;
  width: 14rem;
  height: 3.5rem;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  animation: slide backwards;
  animation-duration: 500ms;
  animation-delay: 400ms;

  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  @media (min-width: 900px) {
    width: 30vh;
    height: 8vh;
  }

  &:hover {
    background-color: ${(props) => props.theme.palette.button.startHover};
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 14px 14px 28px rgba(0, 0, 0, 0.25),
      0 8px 8px rgba(0, 0, 0, 0.22);
    transform: scale(1.1);
  }

  img {
    width: 100%;
  }
`;
